/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentSummaryData {
    getFixupPrototypeFunction() { return AssessmentSummaryData.fixupPrototype; }

    static newInstance(model: Partial<AssessmentSummaryData>): AssessmentSummaryData {
        let obj = Object.assign(new AssessmentSummaryData(), model);
        AssessmentSummaryData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentSummaryData>): AssessmentSummaryData {
        if (!model) return null;
        return AssessmentSummaryData.newInstance(<AssessmentSummaryData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentSummaryData) {
        if (!obj) return;

        models.AssessmentSummaryData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentSummaryData): boolean {
        Object.setPrototypeOf(obj, AssessmentSummaryData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.violations === undefined) {
            this.violations = 0;
        }
        if (this.failures === undefined) {
            this.failures = 0;
        }
        if (this.completed === undefined) {
            this.completed = 0;
        }
        if (this.in_progress === undefined) {
            this.in_progress = 0;
        }
    }

    /**
     * Number of controls violated
     */
    violations: number;

    /**
     * Number of controls that failed
     */
    failures: number;

    /**
     * Number of controls that executed successfully
     */
    completed: number;

    /**
     * Number of controls currently in progress
     */
    in_progress: number;

}
